import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_FILTER_ALL } from "@/constants/sparxsCatalogFilters";
import { clearSparxsCatalogFiltersToDefaults } from "@/store/statistics/sparxsCatalogFiltersActions";

const CategoryFilterSlice = createSlice({
  name: "categoryFilter",
  initialState: DEFAULT_FILTER_ALL,
  reducers: {
    updateCategory: (_, action: PayloadAction<string>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(
      clearSparxsCatalogFiltersToDefaults,
      () => DEFAULT_FILTER_ALL,
    );
  },
});

export const { updateCategory } = CategoryFilterSlice.actions;
export default CategoryFilterSlice.reducer;
